<ng-container *ngIf="bundlesWithCourse.length > 0;">
  <a name="related-bundles"></a>
  <h6>Discount Packages with this Course</h6>
  <ul>
    <li *ngFor="let bundle of bundlesWithCourse">
      <a class="d-block" [routerLink]="'../../package/' + bundle.alias">{{bundle.title}}</a>
      <em *ngIf="bundle.Access" class="pl-2">Valid through {{bundle.Expires | date:'mediumDate'}} </em>
    </li>
  </ul>
</ng-container>